import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AddStockAdjustment = () => {
    const [category, setCategory] = useState('');
    const [subCategory, setSubCategory] = useState('');
    const [pcs, setPcs] = useState('');
    const [signature, setSignature] = useState(null);
    const [description, setDescription] = useState('');
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [loading, setLoading] = useState(true); // Track loading state for data fetching
    const [error, setError] = useState(null); // Track any errors during API calls
    const navigate = useNavigate();

    // Fetch categories data from API
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch('http://pbhrm.com/api/categories');
                const data = await response.json();
                if (data.status === 1) {
                    setCategories(data.data);
                } else {
                    setError('Failed to fetch categories');
                }
            } catch (error) {
                setError('Error fetching categories');
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, []);

    // Fetch subcategories data from API
    useEffect(() => {
        const fetchSubcategories = async () => {
            try {
                const response = await fetch('http://pbhrm.com/api/subcategories');
                const data = await response.json();
                if (data.status === 1) {
                    setSubcategories(data.data);
                } else {
                    setError('Failed to fetch subcategories');
                }
            } catch (error) {
                setError('Error fetching subcategories');
            }
        };
        fetchSubcategories();
    }, []);

    // Handle form data changes
    const handleCategoryChange = (event) => setCategory(event.target.value);
    const handleSubCategoryChange = (event) => setSubCategory(event.target.value);
    const handlePcsChange = (event) => setPcs(event.target.value);
    const handleDescriptionChange = (event) => setDescription(event.target.value);
    const handleSignatureChange = (event) => setSignature(event.target.files[0]);

    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validate the form inputs
        if (!category || !subCategory || !pcs || !signature || !description) {
            setError('Please fill all fields');
            return;
        }

        // Prepare form data
        const formData = new FormData();
        formData.append('category', category);
        formData.append('sub_category', subCategory);
        formData.append('pcs', pcs);
        formData.append('signature', signature);
        formData.append('description', description);

        try {
            const response = await fetch('http://pbhrm.com/api/stockadjustments', {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            if (data.status === 1) {
                alert('Stock Adjustment created successfully');
                navigate('/StockAdjustments'); // Redirect to stock adjustments list
            } else {
                setError('Error: ' + data.message);
            }
        } catch (error) {
            setError('Error creating stock adjustment');
            console.error('Error:', error);
        }
    };

    if (loading) {
        return <div>Loading...</div>; // Show loading message while fetching data
    }

    if (error) {
        return <div>Error: {error}</div>; // Display error message if any API call failed
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Stock Adjustment</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Stock Adjustment Form start */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5>Stock Adjustment Form</h5>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/StockAdjustments')}>Back to List</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="category" className="form-label">Category</label>
                                        <select
                                            id="category"
                                            className="form-control"
                                            value={category}
                                            onChange={handleCategoryChange}
                                            required
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map((cat) => (
                                                <option key={cat.id} value={cat.id}>
                                                    {cat.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="subCategory" className="form-label">Sub Category</label>
                                        <select
                                            id="subCategory"
                                            className="form-control"
                                            value={subCategory}
                                            onChange={handleSubCategoryChange}
                                            required
                                        >
                                            <option value="">Select Sub Category</option>
                                            {subcategories.map((subCat) => (
                                                <option key={subCat.id} value={subCat.id}>
                                                    {subCat.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="pcs" className="form-label">Pieces (pcs)</label>
                                        <input
                                            type="number"
                                            id="pcs"
                                            className="form-control"
                                            placeholder="Enter pieces"
                                            value={pcs}
                                            onChange={handlePcsChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="signature" className="form-label">Signature Image</label>
                                        <input
                                            type="file"
                                            id="signature"
                                            className="form-control"
                                            onChange={handleSignatureChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            placeholder="Enter description"
                                            value={description}
                                            onChange={handleDescriptionChange}
                                            required
                                        ></textarea>
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-success">Create Stock Adjustment</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Add Stock Adjustment Form end */}
        </div>
    );
};

export default AddStockAdjustment;
